import countryDetails from "../images/country-details.png";
import eSchool from "../images/e-school.png";
import healthyTeeth from "../images/healthy-teeth.png";
import lazyTraveler from "../images/lazy-traveler.png";
import popularAgency from "../images/popular-agency.png";

const projectsData = [
	{
		title: "Healthy Teeth",
		img: healthyTeeth,
		description:
			"Dental service provider app. Built with React, Express, Mongo and Firebase.",
		website: "https://healthy-teeth.web.app/",
		github: "https://github.com/Tamim-Hossain/healthy-teeth",
	},
	{
		title: "Popular Agency",
		img: popularAgency,
		description:
			"Complete MERN-Stack event managing app. Using React, Heroku and Node.",
		website: "https://popular-agency.web.app/",
		github: "https://github.com/Tamim-Hossain/popular-agency",
	},
	{
		title: "Lazy Traveler",
		img: lazyTraveler,
		description:
			"Hotel booking management app. Using Firebase, Express and React.",
		website: "https://lazy-traveler.web.app/",
		github: "https://github.com/Tamim-Hossain/lazy-traveler",
	},
	{
		title: "Country Details",
		img: countryDetails,
		description:
			"Simple country information viewing website. Using React and Material-UI.",
		website: "https://find-country-details.netlify.app/",
		github: "https://github.com/Tamim-Hossain/country-details",
	},
	{
		title: "e-School",
		img: eSchool,
		description:
			"Online education static website. Using Bootstrap, CSS3 and HTML5.",
		website: "https://tamim-hossain.github.io/e-school/",
		github: "https://github.com/Tamim-Hossain/e-school",
	},
];

export default projectsData;
